import {NO_ERRORS_SCHEMA, NgModule} from '@angular/core';
import {DfMeDropdownComponent} from './df-me-dropdown/df-me-dropdown.component';
import {DfMeDropdownNodeComponent} from './df-me-dropdown/tree-node/df-me-dropdown-node/df-me-dropdown-node.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SharedDirectivesModule} from '../_directives/shared-directives.module';
import {FormReivewPdfComponent} from './form-review-pdf/form-review-pdf.component';
import { LoaderComponent } from './loader/loader.component';
import { NgReallyActionComponent } from './ng-really-click/ng-really-click.component';
import { ngReallyClickDirective } from './ng-really-click/ng-really-click.directive';
import { GtwCustomSnackbarComponent } from './gtw-custom-snackbar/gtw-custom-snackbar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ConfirmationModalModule } from './confirmation-modal/confirmation-modal.module';
import { YearPickerPopupComponent } from './year-picker-popup/year-picker-popup.component';
import { DatePickerWithClearModule } from './date-picker-with-clear/date-picker-with-clear.module';
import { AppNgAppkitModule } from '../../app-ng-appkit.module';
import { ActionConfirmationModalComponent } from './action-confirmation-modal/action-confirmation-modal.component';
import { NullableNumberInputComponent } from './nullable-number-input/nullable-number-input.component';
import { PaginationWrapperModule } from './pagination-wrapper/pagination-wrapper.module';
import { TbPdfPreviewComponent } from './tb-pdf-preview/tb-pdf-preview.component';

@NgModule({
  declarations: [
    DfMeDropdownComponent, 
    DfMeDropdownNodeComponent, 
    FormReivewPdfComponent,
    LoaderComponent,
    NgReallyActionComponent, 
    ngReallyClickDirective,
    GtwCustomSnackbarComponent,
    YearPickerPopupComponent,
    ActionConfirmationModalComponent,
    NullableNumberInputComponent,
    TbPdfPreviewComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedDirectivesModule,
    MatButtonModule,
    MatSnackBarModule,
    AppNgAppkitModule,
    PaginationWrapperModule,
    ConfirmationModalModule,
    DatePickerWithClearModule,
  ],
  exports: [
    DfMeDropdownComponent, 
    DfMeDropdownNodeComponent, 
    FormReivewPdfComponent,
    LoaderComponent,
    NgReallyActionComponent, 
    ngReallyClickDirective,
    GtwCustomSnackbarComponent,
    ConfirmationModalModule,
    DatePickerWithClearModule,
    YearPickerPopupComponent,
    AppNgAppkitModule,
    ActionConfirmationModalComponent,
    NullableNumberInputComponent,
    PaginationWrapperModule,
    TbPdfPreviewComponent,
  ],
  schemas: [NO_ERRORS_SCHEMA]
})
export class SharedComponentsModule {
}
